import { Viewer } from "@photo-sphere-viewer/core";
import { AutorotatePlugin } from "@photo-sphere-viewer/autorotate-plugin";

import "@photo-sphere-viewer/core/index.css";
import "./style.css";

/**
 * Start age-gate script
 */

// Shared helper: initialise a single viewer container from its data-settings
function initViewerElement(el) {
  if (el.dataset.psvInitialized) return;
  el.dataset.psvInitialized = "1";

  var settings =
    typeof jQuery !== "undefined"
      ? jQuery(el).data("settings")
      : JSON.parse(el.getAttribute("data-settings") || "{}");

  if (!settings || !settings.container) return;

  var navbar = settings.navbar || false;
  new Viewer({
    ...settings,
    navbar: navbar,
    plugins:
      navbar && (Array.isArray(navbar) ? navbar : String(navbar)).includes("autorotate")
        ? [
            AutorotatePlugin.withConfig({
              autostartDelay: 1000,
              autorotatePitch: "5deg",
            }),
          ]
        : [],
  });
}

(function ($) {
  "use strict";

  var PhotoSphereViewer = function ($scope, $) {
    var $container = $scope.find(".photo-sphere-viewer");

    if (!$container.length) {
      return;
    }

    $.each($container, function () {
      initViewerElement(this);
    });
  };

  jQuery(window).on("elementor/frontend/init", function () {
    var elementorFrontend = window.elementorFrontend;
    if (elementorFrontend && elementorFrontend.hooks) {
      elementorFrontend.hooks.addAction(
        "frontend/element_ready/photo-sphere-viewer.default",
        PhotoSphereViewer
      );
    }
  });

  // Fallback: initialise any Elementor widget viewers that were NOT handled
  // by Elementor's frontend handler (e.g. when Elementor's init crashes).
  jQuery(function () {
    document.querySelectorAll(".photo-sphere-viewer[data-settings]").forEach(function (el) {
      initViewerElement(el);
    });
  });
})(jQuery);

/**
 * End age-gate script
 */


// init shortcodes scripts
document.querySelectorAll(".xero-psv-container").forEach(function (wrapper) {
  var el = wrapper.firstElementChild;
  if (!el) return;

  var settings = el.getAttribute("data-settings");
  var parsedSettings = JSON.parse(settings || "{}");

  // Ensure navbar is ordered consistently for shortcode viewers
  var desiredOrder = [
    "zoom",
    "move",
    "autorotate",
    "caption",
    "download",
    "fullscreen",
    "description",
  ];

  var navbar = parsedSettings.navbar;

  if (navbar == "") {
    navbar = false;
  } else if (Array.isArray(navbar)) {
    navbar = navbar
      .slice()
      .sort(function (a, b) { return desiredOrder.indexOf(a) - desiredOrder.indexOf(b); });
  } else if (typeof navbar === "string" && navbar.length > 0) {
    var parts = navbar.split(",");
    navbar = parts.sort(
      function (a, b) { return desiredOrder.indexOf(a) - desiredOrder.indexOf(b); }
    );
  }

  if (el) {
    new Viewer({
      ...parsedSettings,
      navbar: Array.isArray(navbar) ? navbar : false,
      plugins: Array.isArray(navbar) && navbar.includes("autorotate")
        ? [
          AutorotatePlugin.withConfig({
            autostartDelay: 1000,
            autorotatePitch: "5deg",
          }),
        ]
        : [],
    });
  }
});